import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id  : 0,
        project_id  : 0,
        feedback_id : 0,
        type        : '',
        data        : '',
        timestamp   : 0,
        status      : 0
    }
});
